var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"text"},[_vm._v("@"+_vm._s((new Date()).getFullYear())+" - mc2i - Developed by DNI v"+_vm._s(_vm.vesrion))])])
}
var staticRenderFns = []

export { render, staticRenderFns }